import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcPrevChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.6368 3.36321C16.9883 3.71468 16.9883 4.28453 16.6368 4.636L9.27318 11.9996L16.6368 19.3632C16.9883 19.7147 16.9883 20.2845 16.6368 20.636C16.2853 20.9875 15.7155 20.9875 15.364 20.636L7.36399 12.636C7.01252 12.2845 7.01252 11.7147 7.36399 11.3632L15.364 3.36321C15.7155 3.01174 16.2853 3.01174 16.6368 3.36321Z",
		fill: "currentColor"
	})
});
export default SvgIcPrevChevron;
